import PaymentForm from './PaymentForm';

export default PaymentForm;
